import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";
import axios from "axios";

interface GetExchangeRateRequest {
  token: string;
  currency1: string | undefined;
  currency2: string | undefined;
}

export interface GetExchangeRateResponse {
  currencyPair: string;
  bid: number;
  ask: number;
  inverse: Inverse;
}

interface Inverse {
  currencyPair: string;
  bid: number;
  ask: number;
}

const getExchangeRate = async ({
  token,
  currency1,
  currency2,
}: GetExchangeRateRequest): Promise<GetExchangeRateResponse> => {
  try {
    const response = await axios.get(
      `${getBaseUrl(Microservice.PAYMENT)}/payment/ledger/getExchangeRate`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          currency1,
          currency2,
        },
      },
    );

    return response.data;
  } catch (err) {
    const message = getApiResponseErrorMsg(err);

    throw new Error(message);
  }
};

export default getExchangeRate;
